import { PublicMeetingDetailsResponseType } from '../lib/api';
import { getKvContentKnovioUrl } from '../lib/api/utils';
import { KV_PARAMS } from '../lib/kv-embed/KvEmbedTrackingService';
import useAttendeeToken from './use-attendee-token';
import { JoinMethod } from '../lib/join-method/join-method';

export type ConnectionPublicDetailsType = PublicMeetingDetailsResponseType & {
  joinUrl?: string | null;
};

/*
* Connection method precedence:
* 1 - Generated panelist joinUrl (meeting-link Create Panelist Link)
* 2 - Attendee level connection
* 2.1 - embedCodeId
* 2.2 - connectionLink
* 3 - Link set for an Attendee
*/

export const openWindow = (url?: string): void => {
  window.open(url ?? '', '_blank');
};

export default function useConnectToPublicMeetingMethod(details: ConnectionPublicDetailsType, joinMethod: JoinMethod | null): () => void {
  const attendeeToken = useAttendeeToken();

  return () => {
    if (!details) return;

    const { attendeeLink, joinUrl } = details;

    if (joinUrl) {
      return openWindow(joinUrl);
    }

    if (joinMethod) {
      if (joinMethod.isKnovioConnectionType()) {
        const url = `${getKvContentKnovioUrl(joinMethod.embedCodeId)}?${KV_PARAMS.KV_ID}=${attendeeToken}`;

        return openWindow(url);
      }

      return openWindow(joinMethod.connectionLink);
    }

    return openWindow(attendeeLink);
  };
}
